<template>
  <div class="text-start">
  <v-col 
    class="white black--text" 
    :style="!$vuetify.breakpoint.smAndDown ? 'position: absolute; width: 60%; left: 0.8cm; top: 0cm; z-index: 1;' : 'position: absolute; width: 100%; left: 0cm; top: 0cm; z-index: 1;'">
    <v-container>
      <v-row>
        <v-col>
          <v-btn
            class="primary btn"
            height="45"
            style="border-radius: 30px;"
            v-on:click="goBack">Go back
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <!-- <v-col>
          Quote <span class="primary--text">#{{  + Number.parseInt(order+1) }}</span>
        </v-col> -->
      </v-row>
      <br/>
      <div>
        <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
          <v-col>
            <h1 class="mb-4">Here's your quote</h1>
          </v-col>
          <v-col>
            <h1 class="primary--text">R{{ truckType.price }}</h1>
          </v-col>
        </v-row>
        <v-row style="display: block;">
          <v-col>
            <v-card elevation="10" height="100%" class="grey lighten-4">
              <v-card-text>
                <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
                  <v-col>
                    <h2 class="black--text mb-4">Collection Address</h2> 
                    {{ address1 }}
                  </v-col>
                  <v-col>
                    <h2 class="black--text mb-4">Delivery Address</h2> 
                    {{ address2 }}
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br/><br/>
        <v-row>
          <v-col>
            Quote details
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <br/>

        <Loading v-if="loading"/>

        <v-row class="pl-3" style="display: block;" v-else>
          <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
            <v-col>
              <h4 class="black--text mb-2">Service type </h4>
              {{ serviceType }}
            </v-col>
            <v-col>
              <h4 class="black--text mb-2">Truck type </h4>
              <span> {{ truckType.name }} </span>
            </v-col>
            <v-col>
              <h4 class="black--text mb-2">Email address </h4>
              <span> {{ user.emailAddress }} </span>
            </v-col>
            <v-col>
              <h4 class="black--text mb-2">Contact number </h4>
              <span> {{ user.mobile }} </span>
            </v-col>
          </v-row>
          <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
            <v-col v-if="living_room_items.length > 0">
              <h4 class="black--text mb-2"> Living room items </h4>
              <span> {{ living_room_items.join(", ") }} </span>
            </v-col>
            <v-col v-if="dinning_room_items.length > 0">
              <h4 class="black--text mb-2"> Dinning room items </h4>
              <span> {{ dinning_room_items.join(", ") }} </span>
            </v-col>
            <v-col v-if="bedroom_items.length > 0">
              <h4 class="black--text mb-2"> Bedroom items </h4>
              <span> {{ bedroom_items.join(", ") }} </span>
            </v-col>
          </v-row>
          <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
            <v-col v-if="kitchen_items.length > 0">
              <h4 class="black--text mb-2"> Kitchen items </h4>
              <span> {{ kitchen_items.join(", ") }} </span>
            </v-col>
            <v-col v-if="storage_items.length > 0">
              <h4 class="black--text mb-2"> Storage items </h4>
              <span> {{ storage_items.join(", ") }} </span>
            </v-col>
            <v-col v-if="other_items.length > 0">
              <h4 class="black--text mb-2"> Other items </h4>
              <span> {{ other_items }} </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="special_instructions.length > 0" class="black--text">
              <h4 class="mb-2"> Special Instructions </h4>
              <span>{{ special_instructions }}</span>
            </v-col>
          </v-row>
        </v-row>
        <br/><br/>
        <v-row style="display: block;">
          <v-col align="start" style="display: block; text-align: center;">
            <v-btn block rounded height="60" class="primary min-width" v-on:click="saveQuoteEventHandler" :disabled="loading">Send Quote</v-btn>
          </v-col>
        </v-row>
        <br/>
        <v-divider></v-divider>
        <br/>
        <v-row class="main--text mb-2" justify="center">
          <v-col>
            <p class="head1">Solve furniture removal hassles.</p>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </div>
    </v-container>
  </v-col>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

export default {
  name: "ConfirmInfo",
  props: {
    goBack: {
      type: Function,
      default: () => null
    },
    address1: {
      type: String,
      default: () => "",
    },
    address2: {
      type: String,
      default: () => "",
    },
    serviceType: {
      type: String,
      default: () => "",
    },
    truckType: {
      type: Object ,
      default: () => null
    },
    user: {
      type: Object,
      default: () => {},
    },
    living_room_items: {
      type: Array,
      default: () => [],
    },
    dinning_room_items:{
      type: Array,
      default: () => [],
    },
    bedroom_items: {
      type: Array,
      default: () => [],
    },
    kitchen_items: {
      type: Array,
      default: () => [],
    },
    storage_items: {
      type: Array,
      default: () => [],
    },
    other_items: {
      type: String,
      default: () => "",
    },
    special_instructions: {
      type: String, 
      default: () => "",
    }

  },
  components:{
    Loading
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async saveQuoteEventHandler() {
      this.loading = true;
      const sendQuote = httpsCallable(functions, "sendQuote");
      await sendQuote({
        address1: this.address1,
        address2: this.address2,
        serviceType: this.serviceType,
        truckType: this.truckType,
        user: this.user,
        living_room_items: this.living_room_items,
        dinning_room_items: this.dinning_room_items,
        bedroom_items: this.bedroom_items,
        kitchen_items: this.kitchen_items,
        storage_items: this.storage_items,
        other_items: this.other_items,
        special_instructions: this.special_instructions,
      }).then(() => {
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-success',
          title: 'Success',
          message: 'Quote sent. We will be in touch soonest! Thanks.',
          options: {
            timeout: 3000
          }
        });
        setTimeout(() => {
          this.$router.go();
        }, 3000);
      }).catch((err) => {
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-danger',
          title: 'Error',
          message: 'Something went wrong. please try again. if the error persists, please contact us.',
          options: {
            timeout: 3000
          }
        });
        console.log(err);
        this.loading = false;
      })
    }
  },
  computed: {

  }
}
</script>

<style scoped>
.head1{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750px;
  font-size: 46px;
  line-height: 64px;
}
.min-width {
  width: 150px;
}
.btn{
  width: 200px;
}

</style>
